export default "__VITE_ASSET__f65dea5a__"